import { useTranslation } from 'react-i18next'

import { ArrowsLeftRightIcon, ArrowUDownLeftIcon } from '@phosphor-icons/react'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'

import ReturnsAndExchangesBarsChart from './ReturnsAndExchangesBarsChart/ReturnsAndExchangesBarsChart'
import ReturnsAndExchangesPieChart from './ReturnsAndExchangesPieChart/ReturnsAndExchangesPieChart'
import ReturnsAndExchangesRatioContentSkeleton from './ReturnsAndExchangesRatioContentSkeleton/ReturnsAndExchangesRatioContentSkeleton'
import { getDataWithGapAttribute } from './helpers'
import * as Styles from './styles'

const ReturnsAndExchangesRatioContent = ({ filters, loading, data, setChartFilters }) => {
  const { t } = useTranslation()

  const handleChangeTimeDisplay = value => {
    setChartFilters(prev => ({ ...prev, timeDisplayReturnsExchanges: value }))
  }

  if (loading) return <ReturnsAndExchangesRatioContentSkeleton />
  if (!data?.results?.length) return <NoResultsFound />

  return (
    <Styles.ChartsContainer>
      <ReturnsAndExchangesPieChart
        data={[
          {
            name: t('Devoluciones'),
            value: Number(data?.total_refund_percentage),
            count: data?.total_refund_count,
            Icon: ArrowUDownLeftIcon,
          },
          {
            name: t('Cambios'),
            value: Number(data?.total_exchange_percentage),
            count: data?.total_exchange_count,
            Icon: ArrowsLeftRightIcon,
          },
        ]}
      />
      <Styles.ChartContainer>
        <ReturnsAndExchangesBarsChart
          data={getDataWithGapAttribute(data?.results)}
          timeRangeSelected={filters?.timeRange}
          timeDisplay={filters?.timeDisplayReturnsExchanges}
          onChangeTimeDisplay={handleChangeTimeDisplay}
          loading={loading}
          showOpenInModal={data?.results?.length > 0}
          modalTitle={
            <Styles.ModalTitle>
              <ArrowUDownLeftIcon size={24} />
              {t('Distribución de cambio/devoluciones')}
            </Styles.ModalTitle>
          }
        />
      </Styles.ChartContainer>
    </Styles.ChartsContainer>
  )
}

export default ReturnsAndExchangesRatioContent
